import { render, staticRenderFns } from "./survey-step-heart-attack-experience.vue?vue&type=template&id=e2d116ea"
import script from "./survey-step-heart-attack-experience.vue?vue&type=script&lang=js"
export * from "./survey-step-heart-attack-experience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports